import graphql__d7bef36823475f23ae32 from "./__generated__/ContributionsDatavizThemesNavigationTheme_themeDetails.graphql.js";
import graphql__1a2f5dba741e64883593 from "./__generated__/ContributionsDatavizThemesNavigationTheme_theme.graphql.js";
import graphql__eb485fc3df37bc01bf12 from "./__generated__/ContributionsDatavizThemesNavigationTheme_participativeModule.graphql.js";import { useCallback, useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import { hasHtmlContent } from "../../../Utils/htmlStringUtils";
import RichText from "../../../Utils/RichText";
import Icon from "../../../Utils/Icon";
import ButtonLink from "../../../Buttons/ButtonLink";
import { useRoutesContext } from "../../../Routes/RoutesContext";
import Tooltip from "../../../Tooltip/Tooltip";
import ContributionsDatavizThemeMeasures from "./ContributionsDatavizThemeMeasures";

const ContributionsDatavizThemesNavigationTheme = props => {
  const theme = useFragment(ContributionsDatavizThemesNavigationTheme_theme, props.theme);
  const { name, children, description } = theme;

  const participativeModule = useFragment(
    ContributionsDatavizThemesNavigationTheme_participativeModule,
    props.participativeModule
  );
  const participativeModuleSlug = participativeModule.slug;

  const { graphViewActive, isLastTheme, displayAsOneLevel } = props;

  const themeRouteName = graphViewActive ? "datavizGraphTheme" : "datavizListTheme";

  const { pathFor } = useRoutesContext();

  const themePathFor = useCallback(
    ({ slug: themeSlug }) =>
      pathFor(themeRouteName, {
        participativeModuleSlug,
        themeSlug
      }),
    [participativeModuleSlug, pathFor, themeRouteName]
  );

  const displayedCircleThemes = useMemo(() => {
    if (displayAsOneLevel || !children.length) return [theme];
    return children;
  }, []);

  const circleThemes = useMemo(() => {
    const CircleThemeContainerTagName = displayAsOneLevel ? "span" : "li";
    const className = classNames("d-inline-block", {
      "margin-right-xs": !displayAsOneLevel,
      "margin-right-xxs": displayAsOneLevel
    });

    return displayedCircleThemes.map(circleTheme => (
      <CircleThemeContainerTagName key={circleTheme.id} className={className}>
        <ButtonLink
          data-sub-theme-icon={circleTheme.id}
          href={themePathFor(circleTheme)}
          style={{
            backgroundColor: circleTheme.primaryColor,
            color: circleTheme.primaryContrastColor
          }}
          className="btn btn-unstyled icon d-block text-center text-smaller pointer"
        >
          <Icon className={classNames([circleTheme.iconClass, "align-middle"])} />
          <span className="sr-only">{circleTheme.name}</span>
        </ButtonLink>
      </CircleThemeContainerTagName>
    ));
  }, []);

  const className = classNames(
    "theme padding-x-xs",
    {
      "margin-bottom-xs": !isLastTheme,
      "padding-bottom-xs": !isLastTheme,
      "border-bottom": !isLastTheme
    },
    props.className
  );

  return (
    <div className={className}>
      <Tooltip
        content={<ContributionsDatavizThemeMeasures theme={theme} />}
        className="dataviz-theme-navigation-tooltip"
      >
        <h3 className="name d-inline-block text-uppercase text-default font-weight-bold margin-bottom-xxs">
          {displayAsOneLevel && circleThemes}
          {name}
        </h3>
      </Tooltip>

      {hasHtmlContent(description) && (
        <RichText
          className="text-small description margin-bottom-xxs"
          content={description}
        />
      )}

      {!displayAsOneLevel && (
        <ul className="padding-none margin-bottom-none">{circleThemes}</ul>
      )}
    </div>
  );
};

ContributionsDatavizThemesNavigationTheme.defaultPropos = {
  listMode: false
};

graphql__d7bef36823475f23ae32;

const ContributionsDatavizThemesNavigationTheme_theme = graphql__1a2f5dba741e64883593;

const ContributionsDatavizThemesNavigationTheme_participativeModule = graphql__eb485fc3df37bc01bf12;

export default ContributionsDatavizThemesNavigationTheme;
